module.exports = __webpack_public_path__ + "media/images/icon_a4_blue-43fdd8f7fe58c874748899be43a501ce.png";